/**
 * Movement component - handles unit movement with pathfinding support
 */

import type { Waypoint } from '@/core/utils/Pathfinding';

export interface MovementComponent {
  speed: number;
  targetX: number | null;
  targetZ: number | null;
  velocityX: number;
  velocityZ: number;
  isPlayerCommand: boolean; // True if this movement was issued by the player
  // Saved destination for resuming after combat
  savedTargetX: number | null;
  savedTargetZ: number | null;
  savedIsPlayerCommand: boolean;
  // Pathfinding waypoints
  path: Waypoint[] | null;
  currentWaypointIndex: number;
  // Final destination (for path recalculation)
  finalTargetX: number | null;
  finalTargetZ: number | null;
  // Path recalculation tracking
  pathRecalcTimer: number;
  stuckTimer: number;
  lastX: number;
  lastZ: number;
}

export function createMovement(speed: number = 1.0): MovementComponent {
  return {
    speed,
    targetX: null,
    targetZ: null,
    velocityX: 0,
    velocityZ: 0,
    isPlayerCommand: false,
    savedTargetX: null,
    savedTargetZ: null,
    savedIsPlayerCommand: false,
    path: null,
    currentWaypointIndex: 0,
    finalTargetX: null,
    finalTargetZ: null,
    pathRecalcTimer: 0,
    stuckTimer: 0,
    lastX: 0,
    lastZ: 0,
  };
}
